import { IDefaultPaymentMethod } from '@mopla/data-models';

const hiddenCardNumber = '****';

export const getLastFourDigits = (
	paymentMethod: IDefaultPaymentMethod
): string => {
	const { type, card, sepa_debit } = paymentMethod;

	switch (type) {
		case 'card':
		case 'apple_pay':
		case 'google_pay':
			return card?.wallet?.dynamic_last4 || card?.last4 || '';
		case 'sepa_debit':
			return sepa_debit?.last4 || '';
		default:
			return '';
	}
};

export const formatExpiryDate = (month: number, year: number): string => {
	const formattedMonth = month.toString().padStart(2, '0');
	const formattedYear = year.toString().slice(-2);
	return `${formattedMonth}/${formattedYear}`;
};

export const getPaymentPrimaryText = (
	paymentMethod: IDefaultPaymentMethod
): string => {
	const { type, paypal, billing_details } = paymentMethod;

	const lastFour = getLastFourDigits(paymentMethod);

	switch (type) {
		case 'card':
		case 'apple_pay':
		case 'google_pay':
		case 'sepa_debit':
			return lastFour ? `${hiddenCardNumber} ${lastFour}` : hiddenCardNumber;
		case 'paypal':
			return paypal?.payer_email || '';
		case 'klarna':
			return billing_details?.email || 'Klarna';
		case 'revolut_pay':
			return billing_details?.email || 'Revolut Pay';
		case 'amazon_pay':
			return billing_details?.email || 'Amazon Pay';
		case 'pay_by_bank':
			return billing_details?.email || 'Pay by Bank';
		default:
			return '';
	}
};

export const getExpiryDate = (
	paymentMethod: IDefaultPaymentMethod
): string | undefined => {
	const { type, card } = paymentMethod;

	if (
		(type === 'card' || type === 'apple_pay' || type === 'google_pay') &&
		card
	) {
		return formatExpiryDate(card.exp_month, card.exp_year);
	}

	return undefined;
};
